// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a23611c9","488":"72e7b0fa"}[chunkId] + ".chunk.js";
};